module.exports = __webpack_public_path__ + "img/loginHead.71f0f71f.png";